import React, { useState } from 'react';
import Select from 'react-select'; // Ensure you have react-select installed



const Weaknesses = () => {
  const bodyParts = [
    { value: 'Chest', label: 'Chest' },
    { value: 'Back', label: 'Back' },
    { value: 'Shoulders', label: 'Shoulders' },
    { value: 'Biceps', label: 'Biceps' },
    { value: 'Triceps', label: 'Triceps' },
    { value: 'Forearms', label: 'Forearms' },
    { value: 'Abs', label: 'Abs' },
    { value: 'Obliques', label: 'Obliques' },
    { value: 'Quads', label: 'Quads' },
    { value: 'Hamstrings', label: 'Hamstrings' },
    { value: 'Glutes', label: 'Glutes' },
    { value: 'Calves', label: 'Calves' },
    { value: 'Neck', label: 'Neck' },
    { value: 'Traps', label: 'Traps' },
    { value: 'Lower Back', label: 'Lower Back' },
    { value: 'Hip Flexors', label: 'Hip Flexors' },
    { value: 'Adductors', label: 'Adductors' },
    { value: 'Abductors', label: 'Abductors' },
  ];

  const [weaknesses, setWeaknesses] = useState([{ bodyPart: null, severity: 'low' }]);

  const handleAddWeakness = () => {
    setWeaknesses([...weaknesses, { bodyPart: null, severity: 'low' }]);
  };

  const handleChange = (index, field, value) => {
    const updatedWeaknesses = [...weaknesses];
    updatedWeaknesses[index][field] = value;
    setWeaknesses(updatedWeaknesses);
  };

  return (
    <div className="">
      <h1>Weaknesses</h1>
      <p>Specify the client's weaknesses by selecting a body part and its severity level.</p>
      {weaknesses.map((weakness, index) => (
        <div key={index} className="weakness">
          <h2>Client Muscle/Joint Weakness #{index + 1}</h2>
          <label htmlFor={`bodyPart-${index}`}>Body Part Affected:</label>
          <Select
            options={bodyParts}
            value={weakness.bodyPart}
            onChange={(selectedOption) => handleChange(index, 'bodyPart', selectedOption)}
            placeholder="Select Body Part"
          />
          <label htmlFor={`severity-${index}`}>Severity Level:</label>
          <select
            value={weakness.severity}
            onChange={(e) => handleChange(index, 'severity', e.target.value)}
          >
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
          </select>
        </div>
      ))}
      <button className="add-another" onClick={handleAddWeakness}>
        <span className="icon">+</span> Add Another
      </button>
    </div>
  );
};

export default Weaknesses;